// entities/institution/lib/branchLabel — единая подпись филиала для UI/админки.

/**
 * Минимум данных, достаточный для построения подписи филиала.
 * Совместим и с `Branch`, и с любыми облегчёнными DTO.
 */
export interface BranchLabelSource {
  name?: string | null
  address?: { city?: string | null, street?: string | null } | null
}

/**
 * Человекочитаемая подпись филиала.
 *
 * Приоритет — собственное название филиала («Шаурмен на Широкой»): именно оно
 * задаётся в карточке филиала и однозначно различает точки в одном городе
 * (по городу филиалы неотличимы). Если названия нет — собираем «улица, город»,
 * иначе отдаём что есть.
 */
export function getBranchLabel(branch: BranchLabelSource | null | undefined): string {
  if (!branch) return ''
  const name = branch.name?.trim()
  if (name) return name
  const street = branch.address?.street?.trim()
  const city = branch.address?.city?.trim()
  return [street, city].filter(Boolean).join(', ') || 'Филиал'
}
